// Shared constants for member-history log UI.
// Kept in a tiny module so both the filter bar (action select labels) and the
// timeline (badge labels/colors) reuse the same mapping.

export const ACTION_LABELS = {
  created: "Member Dibuat",
  updated: "Member Diupdate",
  deleted: "Member Dihapus",
  submitted: "NDP Disubmit",
  note_added: "Catatan Ditambahkan",
};

export const ACTION_COLORS = {
  created: "bg-green-900/30 text-green-300 border-green-700/40",
  updated: "bg-blue-900/30 text-blue-300 border-blue-700/40",
  deleted: "bg-red-900/30 text-red-300 border-red-700/40",
  submitted: "bg-yellow-900/30 text-yellow-300 border-yellow-700/40",
  note_added: "bg-purple-900/30 text-purple-300 border-purple-700/40",
};
